export default {
  'menu.home': '홈',
  'menu': '투데이몰',
  'menu.todayggigu': '투데이직구',
  'menu.login': '로그인',
  'menu.logout': '로그아웃',
  'menu.products': '운영관리',
  'menu.products.operation-data': '운영 데이터',
  'menu.products.list': '자사몰',
  'menu.products.add': '상품 등록',
  'menu.products.edit': '상품 수정',
  'menu.cs.suggestion': '싸이트평가',
  'menu.products.import-taobao': '프로모션 링크 가져오기',
  'menu.products.categories': '카테고리 관리',
  'menu.products.stores': '스토어 관리',
  'menu.products.live-sellers': '라이브 셀러',
  'menu.products.live-sellers.sellers': '셀러 목록',
  'menu.products.seller-detail': '셀러 상세',
  'menu.products.rebate-settings': '리베이트 설정',
  'menu.products.rebate-settings.rebate-level': '리베이트 레벨',
  'menu.products.rebate-settings.rebate-rules': '리베이트 규칙',
  'menu.products.coupon-point-settings': '포인트/쿠폰 설정',
  'menu.cs.notices': '공지사항',
  'menu.products.search-management': '검색 관리',
  'menu.products.search-management.danger-management': '위험어 관리',
  'menu.products.search-management.edit-search-term': '검색어 편집',
  'menu.operations': '운영관리',
  'menu.operations.operation-data': '운영 데이터',
  'menu.operations.list': '자사몰',
  'menu.operations.add': '상품 등록',
  'menu.operations.edit': '상품 수정',
  'menu.operations.import-taobao': '프로모션 링크 가져오기',
  'menu.operations.categories': '카테고리 관리',
  'menu.operations.stores': '스토어 관리',
  'menu.operations.promo-videos': '홍보 영상 검수',
  'menu.operations.live': '라이브',
  'menu.operations.live.live-sellers': '라이브 셀러',
  'menu.operations.live.live-team-list': '라이브 팀 목록',
  'menu.operations.live.live-rebate-settings': '라이브 리베이트 설정',
  'menu.operations.live.live-page-settings': '라이브 페이지 설정',
  'menu.operations.live.seller-detail': '셀러 상세',
  'menu.operations.live-sellers': '라이브 셀러',
  'menu.operations.live-team-list': '라이브 팀 목록',
  'menu.operations.live-rebate-settings': '라이브 리베이트 설정',
  'menu.operations.store-rebate-settings': '스토어 리베이트 설정',
  'menu.operations.share-rebate-settings': '공유 리베이트 설정',
  'menu.operations.live-page-settings': '라이브 페이지 설정',
  'menu.operations.frontend-pages': '프론트 페이지 설정',
  'menu.operations.seller-detail': '셀러 상세',
  'menu.operations.rebate-settings': '리베이트 설정',
  'menu.operations.rebate-settings.rebate-level': '리베이트 레벨',
  'menu.operations.rebate-settings.rebate-rules': '리베이트 규칙',
  'menu.operations.rebate-settings.live-rebate-settings': '라이브 리베이트 설정',
  'menu.operations.coupon-point-settings': '포인트/쿠폰 설정',
  'menu.operations.search-management': '검색 관리',
  'menu.operations.search-management.danger-management': '위험어 관리',
  'menu.operations.search-management.edit-search-term': '검색어 편집',
  'menu.orders': '주문관리',
  'menu.orders.user': '일반 회원 주문',
  'menu.orders.pending-payment': '결제확인',
  'menu.orders.statistics': '주문 통계',
  'menu.orders.no-data': '노데이타',
  'menu.orders.questions': '주문문의',
  'menu.todayggigu.orders.tradeServices': '무역 서비스',
  'menu.todayggigu.orders.tradeServices.comprehensive': '종합 관리',
  'menu.todayggigu.orders.tradeServices.pendingPayment': '결제 대기',
  'menu.todayggigu.orders.paymentAgency': '결제 대행',
  'menu.todayggigu.orders.paymentAgency.comprehensive': '종합 관리',
  'menu.todayggigu.orders.paymentAgency.pendingPayment': '결제 대기',
  'menu.todayggigu.orders.paymentAgency.forexDepositApplication': '외화 예치금 신청 내역',
  'menu.todayggigu.orders.paymentAgency.forexDepositUsage': '외화 예치금 사용 내역',
  'menu.todayggigu.orders.paymentAgency.forexDepositPayment': '외화 예치금 결제 내역',
  'menu.storehouse': '창고관리',
  'menu.storehouse.express-inspection': '택배 입고 검수',
  'menu.storehouse.non-master-courier': '비주류 택배 입고',
  'menu.storehouse.inspection-list': '검수 목록',
  'menu.storehouse.rack': '랙 관리',
  'menu.storehouse.inventory': '재고관리',
  'menu.storehouse.inventory-detail': '창고 상세',
  'menu.storehouse.warehouse-address': '창고 주소',
  'menu.storehouse.waybill-informations': '운송장 정보',
  'menu.storehouse.waybill-bandwidth-management': '운송장 대역폭 관리',
  'menu.storehouse.transportation-methods': '운송 방법',
  'menu.storehouse.logistics-trajectory': '물류 경로',
  'menu.storehouse.regional-management': '지역 관리',
  'menu.storehouse.international-tracking-number-management': '국제 운송장 관리',
  'menu.storehouse.hs-product-code-management': 'HS 상품 코드 관리',
  'menu.members': '회원관리',
  'menu.members.general': '일반 회원',
  'menu.members.blacklist': '블랙리스트 회원',
  'menu.members.statistics': '회원 통계',
  'menu.members.active-users': '활성 사용자',
  'menu.members.membershipLevelManagement': '회원 등급 관리',
  // RebateLevel, RebateRules, FinancialRecord, Deposit moved to settlement/settings
  'menu.members.rechargeReview': '충전 검토',
  'menu.members.withdrawReview': '출금 검토',
  'menu.members.userPromotionDetail': '회원 프로모션 상세',
  'menu.members.memberDocuments': '회원 문서 관리',
  'menu.members.consumptionChangeDetails': '소비 변동 상세',
  'menu.members.coupon-point-settings': '쿠폰 포인트 설정',
  'menu.statistics': '통계',
  'menu.statistics.visit-analytics': '방문·클릭 분석',
  'menu.settlement': '재무관리',
  'menu.settlement.sellers': '판매자 정산',
  'menu.settlement.dashboard': '대시보드',
  'menu.settlement.platform': '플랫폼 수수료',
  'menu.settlement.deposit-application-history': '예치금신청내역',
  'menu.settlement.deposit-usage-history': '예치금사용내역',
  'menu.settlement.rebate-rules': '리베이트 규칙',
  'menu.settlement.rebate-levels': '리베이트 레벨',
  'menu.settlement.financial-tax-report': '재무 세금 신고서',
  'menu.settlement.financial-record': '재무 기록',
  'menu.settlement.deposit': '입금 관리',
  'menu.settlement.pending-payment': '결제 대기',
  'menu.settlement.share-rebates': '공유 리베이트',
  'menu.settings': '설정',
  'menu.settings.rebate-level': '리베이트 레벨',
  'menu.settings.rebate-rules': '리베이트 규칙',
  'menu.settings.product-price-increase': '상품 가격 인상',
  'menu.settings.service-fee': '서비스 수수료',
  'menu.settings.website-content-management': '웹사이트 콘텐츠 관리',
  'menu.settings.website-content-management.seo-settings': '웹사이트 SEO 설정',
  'menu.settings.website-content-management.email-configuration': '이메일 구성',
  'menu.settings.website-content-management.image-settings': '이미지 설정',
  'menu.settings.website-content-management.basic-configuration': '웹사이트 기본 구성',
  'menu.settings.website-content-management.app-settings': '앱 설정',
  'menu.settings.mail-management': '메일 관리',
  'menu.settings.mail-management.email-template': '이메일 템플릿',
  'menu.settings.mail-management.sms-template': 'SMS 템플릿',
  'menu.settings.mail-management.email-log': '이메일 로그',
  'menu.settings.mail-management.push-message': '푸시 메시지',
  'menu.system-settings': '시스템 설정',
  'menu.settings.admins': '관리자 계정',
  'menu.settings.rates': '환율/관세 설정',
  'menu.settings.purchase-condition-settings': '구매 조건 설정',
  'menu.settings.additional-cost-settings': '추가 비용 설정',
  'menu.settings.additional-service': '추가 서비스',
  'menu.settings.shipping-rate': '배송비요율',
  'menu.settings.work-log': '작업 로그',
  'menu.settings.island-mountain-cost': '도서산간 비용',
  'menu.cs': '게시판 관리',
  'menu.cs.inquiries': '1:1 문의',
  'menu.cs.faq': 'FAQ',
  'menu.cs.help': '헬프센터',
  'menu.cs.banners': '배너/이벤트',
  'menu.todayggigu.cs.event': '이벤트',
  // Search Management and Mail Management moved to settings
  'menu.cs.looking-for-owner': '주인을 찾습니다',
  'menu.cs.reviews': '이용후기',
  'menu.cs.review-write': '리뷰 작성',
  'menu.cs.review-detail': '리뷰 상세',
  'menu.cs.review-edit': '리뷰 수정',
  'menu.todayggigu.orders': '주문관리',
  'menu.todayggigu.orders.business': '사업자 회원 주문',
  'menu.todayggigu.orders.business.orders': '주문',
  'menu.todayggigu.orders.business.pending-payment': '결제 대기',
  'menu.todayggigu.orders.business.no-data': '노데이타',
  'menu.todayggigu.orders.vvic': 'VVIC 하이패스 주문',
  'menu.todayggigu.orders.vvic.orders': '주문',
  'menu.todayggigu.orders.vvic.pending-payment': '결제 대기',
  'menu.todayggigu.orders.vvic.no-data': '노데이타',
  'menu.todayggigu.orders.rocket': '로켓 주문',
  'menu.todayggigu.orders.rocket.orders': '주문',
  'menu.todayggigu.orders.rocket.pending-payment': '결제 대기',
  'menu.todayggigu.orders.rocket.no-data': '노데이타',
  'menu.todayggigu.orders.pending-payment': '결제확인',
  'menu.todayggigu.orders.statistics': '주문 통계',
  'menu.todayggigu.orders.pending-address': '배송지입력대기',
  'menu.todayggigu.orders.in-china-warehouse': '중국창고입고',
  'menu.todayggigu.orders.in-korea-delivery': '배송중',
  'menu.todayggigu.orders.completed': '배송완료',
  'menu.todayggigu.orders.no-data': '노데이타',
  'menu.todayggigu.orders.questions': '주문문의',
  'menu.todayggigu.orders.inventory-questions': '재고문의',
  'menu.todayggigu.lowest-price-products': '최저가 상품',
  'menu.todayggigu.lowest-price-products.list': '상품 목록',
  'menu.todayggigu.lowest-price-products.category': '카테고리 관리',
  'menu.todayggigu.homepage': '홈페이지 관리',
  'menu.todayggigu.homepage.main-rolling-banner': '메인 롤링 배너',
  'menu.todayggigu.homepage.banner-management': '배너 관리',
  'menu.todayggigu.homepage.recommended-products': '추천 상품',
  'menu.todayggigu.homepage.departure-schedule': '출발 일정',
  'menu.todayggigu.homepage.shopping-information': '쇼핑 정보',
  'menu.todayggigu.homepage.event-management': '이벤트 관리',
  'menu.todayggigu.homepage.popup-management': '팝업 관리',
  'menu.todayggigu.homepage.page-management': '페이지 관리',
  'menu.todayggigu.homepage.mail-form-management': '메일 폼 관리',
  'menu.todayggigu.coupon-management': '쿠폰 관리',
  'menu.todayggigu.coupon-management.issuance-details': '쿠폰 발급 내역',
  'menu.todayggigu.coupon-management.coupon-issuance-details': '쿠폰 발급 내역',
  'menu.todayggigu.coupon-management.event-coupon': '이벤트 쿠폰',
  'menu.todayggigu.sms': 'SMS 관리',
  'menu.todayggigu.sms.send': 'SMS 발송',
  'menu.todayggigu.sms.sending-history': '발송 내역',
  'menu.todayggigu.sms.kakao-sms-management': '카카오 SMS 관리',
  'menu.todayggigu.sms.point-details': '포인트 내역',
  'menu.todayggigu.environment-setting': '환경 설정',
  'menu.todayggigu.environment-setting.membership-level': '회원 등급',
  'menu.todayggigu.environment-setting.administrator-management': '관리자 관리',
  'menu.todayggigu.environment-setting.center-management': '센터 관리',
  'menu.todayggigu.environment-setting.shipping-rate': '배송비',
  'menu.todayggigu.environment-setting.deposit-account': '입금 계좌',
  'menu.todayggigu.environment-setting.customs-exchange-rate': '관세 환율',
  'menu.todayggigu.environment-setting.applicable-exchange-rate': '적용 환율',
  'menu.todayggigu.environment-setting.additional-service': '추가 서비스',
  'menu.todayggigu.environment-setting.island-mountain-cost': '도서산간 비용',
  'menu.todayggigu.environment-setting.item-management': '품목 관리',
  'menu.todayggigu.environment-setting.waybill-bandwidth': '운송장 대역폭',
  'menu.todayggigu.members': '회원관리',
  'menu.todayggigu.members.business': '사업자 회원',
  'menu.todayggigu.members.blacklist': '블랙리스트 회원',
  'menu.todayggigu.members.points': '포인트',
  'menu.todayggigu.members.statistics': '회원 통계',
  'menu.todayggigu.members.active-users': '활성 사용자',
  'menu.todayggigu.members.membershipLevelManagement': '회원 등급 관리',
  'menu.todayggigu.members.rebateLevel': '리베이트 등급',
  'menu.todayggigu.members.rebateRules': '리베이트 규칙',
  'menu.todayggigu.members.financialRecord': '재무 기록',
  'menu.todayggigu.members.deposit': '입금 관리',
  'menu.todayggigu.members.userPromotionDetail': '회원 프로모션 상세',
  'menu.todayggigu.members.consumptionChangeDetails': '소비 변동 상세',
  'menu.todayggigu.members.coupons': '쿠폰 관리',
  'menu.todayggigu.members.coupon-point-settings': '쿠폰 포인트 설정',
  'menu.todayggigu.members.depositApplication': '예치금 신청 내역',
  'menu.todayggigu.members.depositUsage': '예치금 사용 내역',
  'menu.todayggigu.members.bankbookVerification': '통장 자동 인증',
  'menu.todayggigu.members.forexDepositApplication': '외화 예치금 신청 내역',
  'menu.todayggigu.members.forexDepositUsage': '외화 예치금 사용 내역',
  'menu.todayggigu.members.forexDepositPayment': '외화 예치금 결제 내역',
  'menu.todayggigu.settlement': '재무관리',
  'menu.todayggigu.settlement.sellers': '판매자 정산',
  'menu.todayggigu.settlement.platform': '플랫폼 수수료',
  'menu.todayggigu.settings': '설정',
  'menu.todayggigu.settings.rebate-level': '리베이트 등급',
  'menu.todayggigu.settings.rebate-rules': '리베이트 규칙',
  'menu.todayggigu.settings.coupons': '포인트/쿠폰 설정',
  'menu.todayggigu.settings.product-price-increase': '상품 가격 인상',
  'menu.todayggigu.settings.service-fee': '서비스 수수료',
  'menu.todayggigu.settings.search-management': '검색 관리',
  'menu.todayggigu.settings.search-management.danger-management': '위험어 관리',
  'menu.todayggigu.settings.search-management.edit-search-term': '검색어 편집',
  'menu.todayggigu.settings.mail-management.website-content-management': '웹사이트 콘텐츠 관리',
  'menu.todayggigu.settings.website-content-management.seo-settings': '웹사이트 SEO 설정',
  'menu.todayggigu.settings.website-content-management.email-configuration': '이메일 구성',
  'menu.todayggigu.settings.website-content-management.image-settings': '이미지 설정',
  'menu.todayggigu.settings.website-content-management.basic-configuration': '웹사이트 기본 구성',
  'menu.todayggigu.settings.website-content-management.app-settings': '앱 설정',
  'menu.list': '목록',
  'menu.add': '추가',
  'menu.todayggigu.bulletin-board': '게시판 관리',
  'menu.todayggigu.bulletin-board.event': '이벤트',
  'menu.todayggigu.bulletin-board.settings': '게시판 설정',
  'menu.todayggigu.bulletin-board.inquiries': '1:1 문의',
  'menu.todayggigu.bulletin-board.inquiries.add': '문의 추가',
  'menu.todayggigu.bulletin-board.inquiries.edit': '문의 수정',
  'menu.todayggigu.bulletin-board.notices': '공지사항',
  'menu.todayggigu.bulletin-board.notices.add': '공지사항 추가',
  'menu.todayggigu.bulletin-board.notices.edit': '공지사항 수정',
  'menu.todayggigu.bulletin-board.faq': 'FAQ',
  'menu.todayggigu.bulletin-board.faq.add': 'FAQ 추가',
  'menu.todayggigu.bulletin-board.faq.edit': 'FAQ 수정',
  'menu.todayggigu.bulletin-board.help': '헬프센터',
  'menu.todayggigu.bulletin-board.banners': '이벤트',
  'menu.todayggigu.bulletin-board.looking-for-owner': '주인을 찾습니다',
  'menu.todayggigu.bulletin-board.looking-for-owner.add': '주인찾기 추가',
  'menu.todayggigu.bulletin-board.looking-for-owner.edit': '주인찾기 수정',
  'menu.todayggigu.bulletin-board.reviews': '이용후기',
  'menu.todayggigu.bulletin-board.reviews.add': '리뷰 추가',
  'menu.todayggigu.bulletin-board.reviews.edit': '리뷰 수정',
  'menu.todayggigu.bulletin-board.suggestion': '건의사항',
  'menu.todayggigu.bulletin-board.suggestion.add': '건의사항 추가',
  'menu.todayggigu.bulletin-board.suggestion.edit': '건의사항 수정',
  'menu.todayggigu.bulletin-board.event.add': '이벤트 추가',
  'menu.todayggigu.bulletin-board.event.edit': '이벤트 수정',
  'menu.todayggigu.bulletin-board.search-management': '검색 관리',
  'menu.todayggigu.bulletin-board.search-management.danger-management': '위험어 관리',
  'menu.todayggigu.bulletin-board.search-management.edit-search-term': '검색어 편집',
  'menu.todayggigu.bulletin-board.mail-management': '메일 관리',
  'menu.todayggigu.bulletin-board.mail-management.email-template': '이메일 템플릿',
  'menu.todayggigu.bulletin-board.mail-management.sms-template': 'SMS 템플릿',
  'menu.todayggigu.bulletin-board.mail-management.email-log': '이메일 로그',
  'menu.todayggigu.bulletin-board.mail-management.push-message': '푸시 메시지',
  'menu.todayggigu.settings.mail-management': '메일 관리',
  'menu.todayggigu.settings.mail-management.email-template': '이메일 템플릿',
  'menu.todayggigu.settings.mail-management.sms-template': 'SMS 템플릿',
  'menu.todayggigu.settings.mail-management.email-log': '이메일 로그',
  'menu.todayggigu.settings.mail-management.push-message': '푸시 메시지',
  'menu.todayggigu.system-settings': '시스템 설정',
  'menu.todayggigu.system-settings.admins': '관리자 계정',
  'menu.todayggigu.system-settings.rates': '환율/관세 설정',
  'menu.todayggigu.system-settings.purchase-condition-settings': '구매 조건 설정',
  'menu.todayggigu.system-settings.shipping-rate': '배송비요율',
  'menu.todayggigu.system-settings.work-log': '작업 로그',
  'menu.todayggigu.bulletin-board.review-write': '리뷰 작성',
  'menu.todayggigu.bulletin-board.review-detail': '리뷰 상세',
  'menu.todayggigu.bulletin-board.review-edit': '리뷰 수정',
  'menu.todayggigu.rack': '랙 관리',
  'menu.todayggigu.rack.management': '랙 관리',
  'menu.todayggigu.rack.usage': '랙 사용 관리',
  'menu.todayggigu.rack.usage-management': '랙 사용 관리',
  'menu.todayggigu.rack.information-log': '랙 정보 로그',
  'menu.todayggigu.statistics': '통계 관리',
  'menu.todayggigu.statistics.order': '주문 통계',
  'menu.todayggigu.statistics.member': '회원 통계',
  'menu.todayggigu.statistics.worker': '작업자 통계',
  'menu.todayggigu.statistics.worker-log': '작업자 로그',
  'menu.todayggigu.statistics.tax-settlement': '세금 정산',
  'menu.todayggigu.statistics.purchase-cost': '구매 비용 통계',
  'menu.todayggigu.statistics.trade-cost': '거래 비용 통계',
  'menu.todayggigu.statistics.payment-agency': '결제 대행 통계',
  'menu.todayggigu.solution-inquiry': '솔루션 문의',
  'menu.system': '시스템관리',
  'menu.system.admins': '관리자 계정',
  'menu.system.roles': '권한 관리',
  'menu.system.rates': '환율/관세 설정',
  'menu.system.purchase-condition-settings': '구매 조건 설정',
  'menu.system.shipping-rate': '배송비요율',
  'menu.system.work-log': '작업 로그',
  'menu.system.banners': '배너/광고 관리',
  'menu.account': '계정',
  'menu.account.center': '개인정보',
  'menu.account.settings': '설정',
  'menu.account.logout': '로그아웃',

  // Trade Services
  'menu.orders.tradeServices': '무역서비스',
  'menu.orders.tradeServices.comprehensive': '종합관리',
  'menu.orders.tradeServices.pendingPayment': '결제대기',

  // Payment Agency
  'menu.orders.paymentAgency': '결제대행',
  'menu.orders.paymentAgency.comprehensive': '종합관리',
  'menu.orders.paymentAgency.pendingPayment': '결제대기',
  'menu.orders.paymentAgency.forexDepositApplication': '외화 예치금 신청 내역',
  'menu.orders.paymentAgency.forexDepositUsage': '외화 예치금 사용 내역',
  'menu.orders.paymentAgency.forexDepositPayment': '외화 예치금 결제 내역',
};
